var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { API } from './api';
import { BaseProvider } from './base';
import { BehaviorSubject } from 'rxjs';
/**
 * This provider allows the app to
 * cache and query information regarding a user
 */
var User = /** @class */ (function () {
    function User() {
        this.capabilities = {};
        this.permissions = {};
        this.organization = new UserOrganization();
    }
    return User;
}());
export { User };
export var UserRole;
(function (UserRole) {
    UserRole["MANAGER"] = "manager";
    UserRole["USER"] = "user";
    UserRole["TAGGER"] = "tagger";
})(UserRole || (UserRole = {}));
var UserOrganization = /** @class */ (function () {
    function UserOrganization() {
    }
    return UserOrganization;
}());
export { UserOrganization };
var Permissions;
(function (Permissions) {
    Permissions["MANAGE_ORGANIZATION"] = "Manage Organization";
    Permissions["MANAGE_USERS"] = "Manage Users";
    Permissions["MANAGE_PROJECTS"] = "Manage Projects";
    Permissions["MANAGE_DATASETS"] = "Manage Datasets";
    Permissions["MANAGE_CLASSES"] = "Manage Classes";
    Permissions["MANAGE_ASSETS"] = "Manage Assets";
    Permissions["MANAGE_EXPORTS"] = "Manage Exports";
    Permissions["MANAGE_USER_ASSIGNMENTS"] = "Manage User Assignments";
    Permissions["MANAGE_TAGS"] = "Manage Tags";
    Permissions["MANAGE_API_KEYS"] = "Manage API Keys";
})(Permissions || (Permissions = {}));
export var Capabilities;
(function (Capabilities) {
    Capabilities["Organization"] = "Enable Organization";
    Capabilities["SwitchAccount"] = "Enable Switch Account";
    Capabilities["APIUsage"] = "Max API Inferences Per Month";
    Capabilities["EnableDetection"] = "Enable Detection";
    Capabilities["EnableDetectionBrains"] = "Enable Detection Brains";
    Capabilities["EnableDetectionTrainingTesting"] = "Enable Detection Training Testing";
    Capabilities["EnableAnomalyRecognition"] = "Enable Anomaly Recognition";
    Capabilities["EnableSceneRecognition"] = "Enable Scene Recognition";
    Capabilities["EnableSegmentation"] = "Enable Segmentation";
    Capabilities["EnableROI"] = "Enable ROI";
    Capabilities["EnableBrainExport"] = "Enable Brain Export";
    Capabilities["EnableWhitelabelDownload"] = "Enable Whitelabel Download";
    Capabilities["EnableDetectionWorkspaceBrain"] = "Enable Detection Workspace Brain";
    Capabilities["EnableDatasetDuplication"] = "Enable Dataset Duplication";
    Capabilities["EnableInferenceAPI"] = "Enable Inference API";
    Capabilities["EnableBrainPromotion"] = "Enable Brain Promotion";
    Capabilities["MaxDatasets"] = "Max Datasets";
    Capabilities["MaxProjects"] = "Max Projects";
    Capabilities["EnableBrainOptimization"] = "Enable Brain Optimization";
    Capabilities["EnableBrainFreezing"] = "Enable Brain Freezing";
    Capabilities["EnableSDKAPI"] = "Enable SDK API";
    Capabilities["EnableAnomalyHiFi"] = "Enable Anomaly Hi-Fi";
    Capabilities["EnableExperimentalFeatures"] = "Enable Experimental Features";
    Capabilities["EnableLicensedFeatureControl"] = "Enable Licensed Feature Control";
    Capabilities["BackboneTargetTierNumber"] = "Backbone Target Tier Number";
})(Capabilities || (Capabilities = {}));
var UserProvider = /** @class */ (function (_super) {
    __extends(UserProvider, _super);
    function UserProvider(api) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.user = new User();
        _this.allowedEmails = [
            'liam@neurala.com',
            'aplumb@neurala.com',
            'vishal@neurala.com',
            'rakesh@neurala.com',
            'emitchell@neurala.com',
            'pmaheshwari@neurala.com',
            'bgong@neurala.com',
            'demo@neurala.com'
        ];
        _this.Capabilities = Capabilities;
        _this.userLoaded = new BehaviorSubject(_this.user);
        return _this;
    }
    UserProvider.prototype.fetchUserInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var userInformation, result, capabilities_1, _i, _a, key, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get('users/information')];
                    case 1:
                        userInformation = _b.sent();
                        result = userInformation.message;
                        capabilities_1 = {};
                        if (result.capabilities) {
                            result.capabilities.forEach(function (capability) {
                                capabilities_1[capability.name] = {
                                    value: capability.value,
                                    enabled: capability.enabled
                                };
                            });
                        }
                        this.user = new User();
                        this.user.email = result.email;
                        this.user.name = result.name;
                        this.user.userIdentifier = result.userIdentifier;
                        this.user.account_tier = result.account_tier;
                        this.user.capabilities = capabilities_1;
                        this.user.permissions = {};
                        this.user.organization = result.organization || new UserOrganization();
                        this.user.usageStatsLimits = result.usageStatsLimits;
                        this.user.usageStatsTotals = result.usageStatsTotals;
                        if (!this.isEmpty(result.permissions)) {
                            for (_i = 0, _a = result.permissions; _i < _a.length; _i++) {
                                key = _a[_i];
                                this.user.permissions[key] = true;
                            }
                        }
                        this.userLoaded.next(this.user);
                        return [2 /*return*/, this.user];
                    case 2:
                        e_1 = _b.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    UserProvider.prototype.fetchUserInformationDebounce = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.debounce('userInformation', function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.fetchUserInformation()];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        });
                    }); }, 250)];
            });
        });
    };
    UserProvider.prototype.load = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.ensureLoaded(function () { return _this.fetchUserInformationDebounce(); }, force)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    UserProvider.prototype.getUserInformation = function () {
        return this.user;
    };
    /**
     * Return information about the user's broad role in an organization (or lack thereof).
     * This is currently used in the dashboard and dataset page components.
     */
    UserProvider.prototype.getUserRole = function () {
        var canManageDatasets = this.canManageDatasets();
        var hasOrganization = this.getUserInformation().organization.organizationIdentifier;
        if (!canManageDatasets) {
            return UserRole.TAGGER;
        }
        else {
            return hasOrganization ? UserRole.MANAGER : UserRole.USER;
        }
    };
    // check if object is empty or not
    UserProvider.prototype.isEmpty = function (obj) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    };
    // if no permission is defined user is not part of organization
    UserProvider.prototype.hasPermission = function (key) {
        return this.isEmpty(this.user.permissions) ? true : this.user.permissions[key] == true;
    };
    UserProvider.prototype.canManageOrganization = function () {
        return this.hasPermission(Permissions.MANAGE_ORGANIZATION);
    };
    UserProvider.prototype.canManageAPIKeys = function () {
        return this.hasPermission(Permissions.MANAGE_API_KEYS);
    };
    UserProvider.prototype.canManageProjects = function () {
        return this.hasPermission(Permissions.MANAGE_PROJECTS);
    };
    UserProvider.prototype.canManageDatasets = function () {
        return this.hasPermission(Permissions.MANAGE_DATASETS);
    };
    UserProvider.prototype.canManageAssets = function () {
        return this.hasPermission(Permissions.MANAGE_ASSETS);
    };
    UserProvider.prototype.canManageClasses = function () {
        return this.hasPermission(Permissions.MANAGE_CLASSES);
    };
    UserProvider.prototype.canManageExports = function () {
        return this.hasPermission(Permissions.MANAGE_EXPORTS);
    };
    UserProvider.prototype.canManageUserAssignments = function () {
        return this.hasPermission(Permissions.MANAGE_USER_ASSIGNMENTS);
    };
    UserProvider.prototype.canManageUser = function () {
        return this.hasPermission(Permissions.MANAGE_USERS);
    };
    UserProvider.prototype.canManageTags = function () {
        return this.hasPermission(Permissions.MANAGE_TAGS);
    };
    UserProvider.prototype.canBuildBrains = function () {
        return this.isNeurala();
    };
    UserProvider.prototype.canExportBrains = function () {
        return this.checkCapability(Capabilities.EnableBrainExport);
    };
    UserProvider.prototype.canSwitchAccount = function () {
        return this.checkCapability(Capabilities.SwitchAccount);
    };
    UserProvider.prototype.hasOrganizationCapability = function () {
        return this.checkCapability(Capabilities.Organization);
    };
    UserProvider.prototype.hasAPIUsageCapability = function () {
        return this.checkCapability(Capabilities.APIUsage);
    };
    UserProvider.prototype.hasEnableWhitelabelDownloadCapability = function () {
        return this.checkCapability(Capabilities.EnableWhitelabelDownload);
    };
    UserProvider.prototype.hasEnableBrainOptimizationCapability = function () {
        return this.checkCapability(Capabilities.EnableBrainOptimization);
    };
    UserProvider.prototype.hasEnableBrainFreezingCapability = function () {
        return this.checkCapability(Capabilities.EnableBrainFreezing);
    };
    UserProvider.prototype.hasDetectionCapability = function () {
        return this.checkCapability(Capabilities.EnableDetection);
    };
    UserProvider.prototype.hasEnableAnomalyRecognitionCapability = function () {
        return this.checkCapability(Capabilities.EnableAnomalyRecognition);
    };
    UserProvider.prototype.hasSceneRecognitionCapability = function () {
        return this.checkCapability(Capabilities.EnableSceneRecognition);
    };
    UserProvider.prototype.hasSegmentationCapability = function () {
        return this.checkCapability(Capabilities.EnableSegmentation);
    };
    UserProvider.prototype.hasDetectionBrainsCapability = function () {
        return this.checkCapability(Capabilities.EnableDetectionBrains);
    };
    UserProvider.prototype.hasDetectionWorkspaceBrainCapability = function () {
        return this.checkCapability(Capabilities.EnableDetectionWorkspaceBrain);
    };
    UserProvider.prototype.isDetectionTrainingTester = function () {
        return this.checkCapability(Capabilities.EnableDetectionTrainingTesting);
    };
    UserProvider.prototype.hasRegionOfInterestCapability = function () {
        return this.checkCapability(Capabilities.EnableROI);
    };
    UserProvider.prototype.hasDatasetDuplicationCapability = function () {
        return this.checkCapability(Capabilities.EnableDatasetDuplication);
    };
    UserProvider.prototype.hasInferenceAPICapability = function () {
        return this.checkCapability(Capabilities.EnableInferenceAPI);
    };
    UserProvider.prototype.hasWhitelabelDownloadCapability = function () {
        return this.checkCapability(Capabilities.EnableWhitelabelDownload);
    };
    UserProvider.prototype.hasBrainPromotionCapability = function () {
        return this.checkCapability(Capabilities.EnableBrainPromotion);
    };
    UserProvider.prototype.hasSDKAPICapability = function () {
        return this.checkCapability(Capabilities.EnableSDKAPI);
    };
    UserProvider.prototype.hasAnomalyHiFiCapability = function () {
        return this.checkCapability(Capabilities.EnableAnomalyHiFi);
    };
    UserProvider.prototype.hasExperimentalFeaturesCapability = function () {
        return this.checkCapability(Capabilities.EnableExperimentalFeatures);
    };
    UserProvider.prototype.canViewAPIKeysPage = function () {
        return this.canManageAPIKeys() && (this.hasInferenceAPICapability() || this.hasSDKAPICapability());
    };
    UserProvider.prototype.isNeurala = function () {
        return this.allowedEmails.includes(this.user.email);
    };
    UserProvider.prototype.hasEnableAnomalyHiFiCapability = function () {
        return this.checkCapability(Capabilities.EnableAnomalyHiFi);
    };
    UserProvider.prototype.hasEnableLicensedFeatureControl = function () {
        return this.checkCapability(Capabilities.EnableLicensedFeatureControl);
    };
    UserProvider.prototype.reset = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.patch('user/reset')];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * check whether a user has a capability or not
     * @param capability capability name
     */
    UserProvider.prototype.checkCapability = function (capability) {
        if (!this.user.capabilities[capability]) {
            return false;
        }
        return this.user.capabilities[capability].enabled == 1;
    };
    UserProvider.prototype.resetInfo = function () {
        _super.prototype.resetInfo.call(this);
    };
    UserProvider.prototype.getCapabilityLimit = function (capability) {
        if (this.user.capabilities[capability]) {
            return this.user.capabilities[capability].value;
        }
        else {
            return null;
        }
    };
    UserProvider.prototype.isWhiteLabelUser = function () {
        return this.hasEnableWhitelabelDownloadCapability();
    };
    UserProvider.prototype.isSonyUser = function () {
        return this.user.account_tier.includes('Sony');
    };
    UserProvider.prototype.isFireflyUser = function () {
        return this.user.account_tier == 'FLIR';
    };
    UserProvider.prototype.isSASTUser = function () {
        return this.user.account_tier == 'SAST';
    };
    UserProvider.prototype.isTaggerUser = function () {
        return this.getUserRole() === UserRole.TAGGER;
    };
    UserProvider.prototype.getBackboneTargetTierNumber = function () {
        return this.getCapabilityLimit(Capabilities.BackboneTargetTierNumber);
    };
    UserProvider.prototype.hasDefaultBackboneTargetTier = function () {
        var number = this.getBackboneTargetTierNumber();
        return number == null || number == 1;
    };
    UserProvider.prototype.getUpgradeLink = function () {
        var user = this.getUserInformation();
        // this prevents user from being undefined and breaking the page if there's a delay in fetching the user in ngOnInit.
        if (user.name) {
            var nameSplit = user.name.split(' ');
            // This assumes that the user has only a first and last name; this might be difficult for non-Western names or those with double names
            var firstName = nameSplit.shift();
            var lastName = nameSplit.join(' ');
            var email = user.email.replace(/\+/g, '%2B');
            return "https://info.neurala.com/upgrade?firstname=" + firstName + "&lastname=" + lastName + "&email=" + email;
        }
    };
    UserProvider.prototype.shouldSeeWhiteLabelCopy = function () {
        return this.isWhiteLabelUser() && !this.isSonyUser();
    };
    /**
     * If this user's account tier has Licensed Feature Control, return the feature availablity we're given
     * Otherwise it should always be available
     */
    UserProvider.prototype.hasLicensedFeatureIfRequired = function (feature) {
        return this.hasEnableLicensedFeatureControl() ? feature : true;
    };
    UserProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API])
    ], UserProvider);
    return UserProvider;
}(BaseProvider));
export { UserProvider };
//# sourceMappingURL=user.js.map


// WEBPACK FOOTER //
// ./src/providers/user.ts.pre-build-optimizer.js